import React from "react";
import { useTranslation } from "react-i18next";

import packageJson from "../../../package.json";

/** MUI */
import { makeStyles } from "@material-ui/core";
import { AppBar, Grid, Toolbar, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    appBar: {
        backgroundColor: theme.palette.background.main,
        boxShadow: "none",
        color: "#000",
    },
    gridItem: {
        display: "flex",
        alignItems: "center",
    },
    statement: {
        display: "block",
        width: "100%",
        textAlign: "center",
        "& a": {
            color: "#000",
        },
    },
    copyright: {
        "& a": {
            color: "#000",
        },
        [theme.breakpoints.down("sm")]: {
            display: "block",
            width: "100%",
            textAlign: "center",
        },
    },
}));

const Footer = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <AppBar position="static" className={classes.appBar}>
                <Toolbar variant="dense">
                    <Grid container>
                        <Grid item xs={12} md={5} className={classes.gridItem}>
                            <Typography variant={"caption"} className={classes.statement}>
                                <a
                                    href={"/statement"}
                                    title={t("Deklaracja dostepnosci")}
                                    alt={t("Deklaracja dostepnosci")}
                                >
                                    {t("Deklaracja dostepnosci")}
                                </a>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md className={classes.gridItem}>
                            <Typography variant={"caption"} className={classes.copyright}>
                                <a href="https://creativecommons.org/licenses/by/4.0/legalcode.pl">
                                    {t("Licencja międzynarodowa Creative Commons BY 4.0 – Uznanie autorstwa")}
                                </a>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md className={classes.gridItem} style={{ justifyContent: "flex-end" }}>
                            <p
                                style={{
                                    fontSize: 8,
                                    color: "#000",
                                    margin: 0,
                                }}
                            >
                                {packageJson.version}
                            </p>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </div>
    );
};

export default Footer;
